export default __webpack_public_path__ + "static/media/a2.8f078805.svg";